import React from 'react';
import {
  Box,
  Container,
} from '@mui/material';
import TravelerCreateAccountForm from '../../../components/traveler-create-account-form';

const CreateAccountView = () => (
  <Container
    maxWidth="sm"
    sx={{ pb: 8 }}
  >
    <Box
      sx={{
        py: {
          desktop: 6,
          mobile: 3,
        },
      }}
    >
      <TravelerCreateAccountForm />
    </Box>
  </Container>
);

export default CreateAccountView;
